import { UserType } from '../../../../models/user-type';
import client from '../../client';

const accountUpdate = async (params: UserType): Promise<void> => {
  const { data } = await client.put<void>('/account/update', params);

  return data;
};

export default accountUpdate;
